import { authenticatedApi, API_BASE_URL } from '../apiUtils';

export const getEmployeePhoto = async (azureId) => {
  try {
    if (!azureId) {
      return null;
    }

    const response = await authenticatedApi.get(`${API_BASE_URL}/employees/azure/${azureId}/photo`);
    
    // Check if response is OK
    if (!response.ok) {
      return null;
    }
    
    // Get content type
    const contentType = response.headers.get('Content-Type') || 'image/jpeg';
    
    // Convert response to blob and set the correct type
    const blob = await response.blob();
    const processedBlob = new Blob([blob], { type: contentType });
    
    // Create a URL for the blob image for the current session
    const photoUrl = URL.createObjectURL(processedBlob);
    
    return photoUrl;
  } catch (error) {
    console.error('Error fetching employee photo:', error);
    return null;
  }
}; 